import { render, staticRenderFns } from "./Outbound.vue?vue&type=template&id=0b5887d0&scoped=true"
import script from "./Outbound.vue?vue&type=script&lang=js"
export * from "./Outbound.vue?vue&type=script&lang=js"
import style0 from "./Outbound.vue?vue&type=style&index=0&id=0b5887d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5887d0",
  null
  
)

export default component.exports